import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-timeline-bottom-toolbar',
  templateUrl: './timeline-bottom-toolbar.component.html',
  styleUrl: './timeline-bottom-toolbar.component.scss',
  standalone: false,
})
export class TimelineBottomToolbarComponent extends BaseComponent {
  constructor() {
    super();
  }
}
